<template>
  <div :class="[visible ? 'visible' : 'hidden']">
    <div class="row">
      <div class="input-field col s12 offset-m1 m10 offset-l3 l6">
        <h3>Bejelentkezés</h3>
        <h5 v-if="clientDisplayNameDefined">Bejelentkezés {{clientDisplayNameArticle}} <span class="client-display-name">{{clientDisplayName}}</span> szolgáltatásba</h5>
      </div>
    </div>
    <form method="POST" autocomplete="on" id="login-form" action="/login">
      <div class="row">
        <div class="input-field col s12 offset-m1 m10 offset-l3 l6">
          <input required type="text" class="form-control" name="login" id="login" v-model="login" autofocus>
          <label for="login">{{loginLabel}}</label>
        </div>
      </div>
      <div class="row">
        <div class="input-field col s12 offset-m1 m10 offset-l3 l6">
          <input required :type="showPassword ? 'text' : 'password'" class="form-control" name="password" id="password" v-model="password">
          <label for="password">Jelszó</label>
          <div class="showPasswordContainer">
            <input class="showPasswordCheckbox" name="showPasswordCheckbox" type="checkbox" v-model="showPassword" />
            <label class="showPasswordCheckboxLabel" for="show-password" @click="showPassword = !showPassword">
              Mutassa
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="input-field col s12 offset-m1 m10 offset-l3 l6">
          <div class="right-align">
            <button v-on:click.prevent="submit()" class="btn waves-effect waves-light" autofocus>
              Bejelentkezés
            </button><br />
            <div class="forgotPassword">
              <a v-link="{ path: 'forgot-password' }" v-if="forgotPasswordEnabled">
                Elfelejtett jelszó
              </a>
            <div class="forgotPassword">
              <a v-link="{ path: 'activation-form' }">
                Aktiválás
              </a>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import $ from 'jquery'
import 'parsleyjs'
import 'material-design-icons-iconfont/dist/material-design-icons.scss'
import config from '../../config'
import db from '../../db'
import {get, post} from '../../api'
import {getReturnTo, getParamFromQueryString, getArticle} from '../../utils'

export default {
  data() {
    return {
      visible: false,
      login: null,
      password: null,
      showPassword: false,
      clientDisplayName: null,
      clientDisplayNameArticle: null,
      viewConfig: {
        shouldUseNavbarWarningBackground: false,
        skin: '',
        couchDbEnabled: false
      }
    }
  },
  created() {
    this.viewConfig = db.get('viewConfig')
  },
  ready() {
    this.init()
    this.initPhoneAutoFormatter()

    window.Materialize.updateTextFields()
  },
  computed: {
    clientDisplayNameDefined() {
      return this.$route.query['return-to'] && this.clientDisplayName
    },
    forgotPasswordEnabled() {
      return config.devMode || config.forgotPasswordEnabled
    },
    loginLabel() {
      if (this.viewConfig.couchDbEnabled) {
        return 'Felhasználónév, email cím vagy telefonszám (formátum: +36 70 123 4567)'
      }
      return 'Felhasználónév'
    }
  },
  methods: {
    init() {
      const returnToUrl = this.$route.query['return-to']
      const clientId = getParamFromQueryString(returnToUrl, 'client_id')

      if (clientId) {
        try {
          get(`/public/ajax/client/${clientId}`, (clientResponse) => {
            if (clientResponse.status === 'ok' && clientResponse.displayName) {
              const displayName = clientResponse.displayName
              this.clientDisplayName = displayName
              this.clientDisplayNameArticle = getArticle(displayName)
            }
            this.visible = true
          })
        } catch (err) {
          console.log('Error while getting client info.', err)
          this.visible = true
        }
      } else {
        this.visible = true
      }
    },
    initPhoneAutoFormatter() {
      $('#login').on('keyup', function(event) {
        // don't run if the user is making a selection in the input
        const selection = window.getSelection().toString()
        if (selection !== '') {
          return
        }
        // don't run if the user is pressing the arrow keys on the keyboard
        if ($.inArray(event.keyCode, [38, 40, 37, 39]) !== -1) {
          return
        }

        const $this = $(this)
        const originalInput = $this.val()
        const trimmedInput = originalInput.replace(/[^0-9+]+/g, '')
        var formattedInput = trimmedInput

        if (trimmedInput.length >= 4 && trimmedInput.length <= 5) {
          formattedInput = `${trimmedInput.substr(0, 3)} ${trimmedInput.substr(3, 2)}`
        } else if (trimmedInput.length >= 6 && trimmedInput.length <= 8) {
          formattedInput = `${trimmedInput.substr(0, 3)} ${trimmedInput.substr(3, 2)} ${trimmedInput.substr(5, 3)}`
        } else if (trimmedInput.length >= 9) {
          formattedInput = `${trimmedInput.substr(0, 3)} ${trimmedInput.substr(3, 2)} ${trimmedInput.substr(5, 3)} ${trimmedInput.substr(8, 12)}`
        }

        if (/^\+36.*/.test(originalInput)) {
          $this.val(formattedInput)
        } else if (/^\+.*/.test(originalInput)) {
          $this.val(trimmedInput)
        } else {
          $this.val(originalInput)
        }
      })
    },
    submit() {
      const valid = $('form').parsley().validate()
      if (valid) {
        post('/public/ajax/login', {username: this.login, password: this.password}, (res) => {
          if (res && res.user) {
            const user = res.user
            db.set('user', user)

            window.location.href = getReturnTo()
          }
        }, {}, false)
      }
    }
  }
}
</script>
<style>
  .client-display-name {

  }
  .showPasswordContainer {
    display: inline;
    float: right;
    margin: -20px 10px 0;
  }

  .visible {
    visibility: visible;
  }
  .hidden {
    visibility: hidden;
  }

  .forgotPassword {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// Login.vue?62ad280a